import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=aea5da02&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=aea5da02&prod&lang=scss&scoped=true"
import style1 from "./comment.vue?vue&type=style&index=1&id=aea5da02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea5da02",
  null
  
)

export default component.exports